import React, { useEffect, useState } from 'react'
import Swal from 'sweetalert2';
import { collection, getDocs, query } from 'firebase/firestore';
import { auth, db } from '../firebase';
import "../App.css";
import Menu from '../panel/Menu';


function Wallet() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();

    const [whatsappCount, setwhatsappCount] = useState(0);
    const [whatsappHist, setwhatsappHist] = useState(0);
    const [emailCount, setemailCount] = useState(0);
    const [smsCount, setsmsCount] = useState(0);
    const [countPaid, setcountPaid] = useState(0);

    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData1()
        });
    }, [userData]);

    const fetchData1 = async () => {
        try {
            if (!userData) return;

            const queries = [
                query(collection(db, 'whatsapphistory'))
            ];

            const snapshots = await Promise.all(queries.map(q => getDocs(q)));
            setwhatsappCount(snapshots[0].size);


            const historyData = snapshots[0].docs.map(doc => doc.data()) || [];
            setwhatsappHist(historyData);


            const querySnapshot = await getDocs(collection(db, 'whatsapp'));
            if (!querySnapshot.empty) {
                setcountPaid(querySnapshot.docs[0].data().countpaid);
            }
        } catch (error) {
            Toast.fire({ icon: 'error', title: error.message });
            console.error(error);
        }
    };



    return (
        <div>
            <Menu />
            <div className="content-wrapper" style={{ backgroundColor: '#fff' }}>
                <section className="content"><br />
                    <div className="container-fluid">
                        <button className="btn btn-secondary " >|| Wallet ||</button><br /><br />
                        <div className="row">
                            <div className="col-md-4 mb-4">
                                <div className="card text-center shadow-lg border-0 rounded-4 overflow-hidden">
                                    <div className="card-header bg-success text-white fw-bold text-uppercase">
                                        Whatsapp
                                    </div>
                                    <div className="card-body">
                                        <h3 className="text-success fw-bold">{(whatsappCount - countPaid) * 1.50}</h3>
                                        <button
                                            className="btn btn-outline-success mt-3 px-4 py-2 rounded-pill"
                                        >
                                            <i className='fa fa-whatsapp'></i> {whatsappCount - countPaid}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 mb-4">
                                <div className="card text-center shadow-lg border-0 rounded-4 overflow-hidden">
                                    <div className="card-header bg-warning text-white fw-bold text-uppercase">
                                        Email
                                    </div>
                                    <div className="card-body">
                                        <h3 className="text-warning fw-bold">{emailCount}</h3>
                                        <button
                                            className="btn btn-outline-warning mt-3 px-4 py-2 rounded-pill"
                                        >
                                            <i className='fa fa-envelope'></i> {emailCount}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 mb-4">
                                <div className="card text-center shadow-lg border-0 rounded-4 overflow-hidden">
                                    <div className="card-header bg-primary text-white fw-bold text-uppercase">
                                        SMS
                                    </div>
                                    <div className="card-body">
                                        <h3 className="text-info fw-bold">{smsCount}</h3>
                                        <button
                                            className="btn btn-outline-primary mt-3 px-4 py-2 rounded-pill"
                                        >
                                            <i className='fa fa-envelope'></i> {smsCount}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className='row'>

                            <table className="table table-bordered table-hover table-striped table-head-fixed">
                                <thead>
                                    <tr>
                                        <th>Sr No</th>
                                        <th> Type </th>
                                        <th>Mobile</th>
                                        <th>Customer</th>
                                        <th>Date Time</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {whatsappHist.length > 0 ? (
                                        whatsappHist.map((item, index) => (
                                            <tr key={index}>
                                                <td>{index+1}</td>
                                                <td>{item.type}</td>
                                                <td>{item.mobile}</td>
                                                <td>{item.custname}</td>
                                                <td>{item.type}</td>
                                            </tr>
                                        ))
                                    ) : (
                                        <p>No history found</p>
                                    )}
                                </tbody>
                            </table>
                        </div> */}


                    </div>
                </section>

            </div>


        </div>
    )
}

export default Wallet
